import { ErrorMessage, Field } from 'formik';

export const StepOne = () => (
  <div className="main-container step">
    {/* <h6 className="text-lg font-medium leading-6 text-gray-900">Basic Information</h6> */}
    <div className=" form-control2">
      <label htmlFor="name" className="text-sm font-medium text-gray-700">
        Name <span>*</span>
      </label>
      <Field
        name="name"
        type="text"
        placeholder="Enter your name"
        className="mt-1   w-full border border-gray-300 rounded-md shadow-sm p-2"
      />
      <ErrorMessage name="name" component="div" className="text-red-500 text-sm" />
    </div>
    <div className=" form-control2">
      <label htmlFor="email" className="block text-sm font-medium text-gray-700">
        Email <span>*</span>
      </label>
      <Field
        name="email"
        type="email"
        placeholder="Enter your email"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
      />
      <ErrorMessage name="email" component="div" className="text-red-500 text-sm" />
    </div>
    <div className="form-control2">
      <label htmlFor="name" className="text-sm font-medium text-gray-700">
        Phone number
      </label>
      <Field
        name="phone"
        type="phone"
        pattern="[0-9]*"
        inputMode="numeric"
        className="mt-1 w-full border border-gray-300 rounded-md shadow-sm p-2"
      />
      <ErrorMessage name="phone" component="div" className="text-red-500 text-sm" />
    </div>
  </div>
);
